import React from 'react';
import {Flex} from "antd";
import styles from './TabButton.module.scss'


interface TabButtonInterface {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  title: string;
  isActive: boolean;
  onClick?: () => void;
}

const TabButton = ({Icon, title, isActive, onClick}: TabButtonInterface) => {

  return (
    <Flex
      className={isActive ? styles.TabButton + ' ' + styles.active : styles.TabButton}
      align={'center'}
      gap={'13px'}
      onClick={onClick}
    >
      <Flex className={styles.TabButton__icon}>
        <Icon />
      </Flex>
      <span className={styles.TabButton__title}>{title}</span>
    </Flex>
  );
};

export default TabButton;